<template>
  <div class="comics-block"
    @pointerdown="handleSpeedHoldStart"
    @pointerup="handleSpeedHoldEnd"
    @pointercancel="handleSpeedHoldEnd"
    @pointerleave="handleSpeedHoldEnd"
  >
    <div
      :class="[
        'comics-header',
        isFullScreen ? 'full-screen' : '',
      ]"
    >
      <div class="navigation">
        <div class="flex justify-center">
          <template v-if="!isPreviewShowing">
            <ComicsComponentIcon
              name="comics_full_screen_icon"
              class="mr-4"
              @click="openFullScreen"
            />
            <ComicsComponentIcon
              v-if="selectedType == comicsConstants.type.instagram"
              name="comics_carousel_mode_icon"
              class="mr-4"
              @click="selectType(comicsConstants.type.carousel)"
            />
            <ComicsComponentIcon
              v-else
              name="comics_mode_icon"
              class="mr-4"
              @click="selectType(comicsConstants.type.instagram)"
            />
          </template>
          <ComicsComponentIcon
            name="comics_close_icon"
            @click="closeComics"
          />
        </div>
      </div>
      <h3 class="header-name font-rubik">
        Mr. Canceller
      </h3>
      <HeaderSettings
        :isPreviewShowing="isPreviewShowing"
        :season="season"
        @setSeason="setSeason"
        :mode="mode"
        @setMode="setMode"
      />
    </div>
    <ComicsComponentIcon
      name="comics_not_full_screen_icon"
      :class="[
        'not-full-screen-btn',
        isFullScreen ? 'full-screen' : '',
      ]"
      @click="closeFullScreen"
    />
    <div
      :class="[
        'view-content',
        isFullScreen ? 'full-screen' : '',
      ]"
    >
      <button
        v-if="isPreviewShowing && isShowStarWarsAnim"
        class="custom-anim-button skip-button"
        @click="skipAnim"
      >
        Skip Intro
      </button>
      <button
        v-if="isPreviewShowing && isShowStarWarsAnim"
        class="custom-anim-button pause-button"
        @click="toggleAnimation"
      >
        {{ isAnimationRunning ? 'Pause' : 'Play' }}
      </button>
      <button
        v-if="isPreviewShowing && isShowStarWarsAnim"
        class="custom-anim-button speed-button"
        @click="toggleSpeedAnimation"
      >
        Speed {{ isAnimationFast ? 'X2' : 'X1' }}
      </button>
      <button
        v-if="isPreviewShowing && isShowStarWarsAnim"
        class="custom-anim-button next-button"
        :class="{ 'next-button--visible': isNextVisible }"
        @click="handleNextClick"
      >
        Next
      </button>
      <div
        v-if="isShowStarWarsAnim"
        class="fade"
      />
      <section
        v-if="isShowStarWarsAnim"
        class="star-wars"
      >
        <div
          ref="crawl"
          :class="[
            'crawl',
            isAnimationRunning ? '' : 'paused',
          ]"
          @animationstart="handleCrawlAnimationStart"
          @animationend="handleCrawlAnimationEnd"
        >
          <p class="intro-text">
            In a galaxy perilously close to the star known as the Sun, a sinister shadow creeps across the cosmos like a bad credit score. Emperor Sorosith and his ruthless apprentice, Darth Trader, have built an empire founded on greed and manipulation. They wield the centralized side of the Force to execute their diabolical plans.<br><br>
            Emperor Sorosith, the tyrannical ruler of the FUDeral Release System (FRS), revels in control and takes perverse pleasure in money-printing robots, known as “battle printers”. These machines work ceaselessly, churning out endless streams of fiat currencies. His conviction is absolute: If it’s a problem, just print enough money to hide it under a cash carpet! Who needs solutions when you’ve got unlimited zeros?<br><br>
            Darth Trader heads the SEC (Supreme Enforcers of Control), a group so entangled in red tape they could gift-wrap a galaxy. They crush economic freedom with layers of bureaucratic decrees.<br><br>
            Together, they are constructing the ultimate weapon—the Death Node. This colossal device is designed to drown independent planets in a deluge of worthless fiat currency, inflating their economies into oblivion.<br><br>
            As their tyranny spreads, smothering planet after planet with financial despair, the galaxy's hope for financial independence wanes. But not all light is lost. From the shadows of oppression, a beacon of Decentralization emerges.
          </p>
        </div>
      </section>
      <ComicsComponentCarousel
        v-else-if="selectedType === comicsConstants.type.carousel"
        :is-full-screen="isFullScreen"
        :season="season"
        :class="[
          'carousel-view',
          isPreviewShowing ? 'is-preview-showing' : '',
        ]"
        :mode="mode"
        @setSeason="setSeason"
      />
      <ComicsComponentInstagram
        v-else-if="selectedType === comicsConstants.type.instagram"
        :is-full-screen="isFullScreen"
        :season="season"
      />
    </div>
    <NuxtLink
      v-if="!isPreviewShowing"
      rel="nofollow"
      target="_blank"
      :to="config.public.mainAppBaseUrl"
      :aria-label="getContent('preview.button_block_button_3')"
      class="launch-app-btn"
    >
      <AppBtn
        :width="breakpoints.mdAndDown ? 108 : 164"
        :height="breakpoints.mdAndDown ? 24 : 48"
        rounded="24"
        class="green-btn"
        :aria-label="getContent('preview.button_block_button_3')"
      >
        <span class="text-uppercase">
          {{ getContent('preview.button_block_button_3') }}
        </span>
      </AppBtn>
    </NuxtLink>
  </div>
</template>

<script>
import HeaderSettings from './HeaderSettings.vue'

export default {
  name: 'ComicsComponent',
  components: {
    HeaderSettings
  },
  data: () => ({
    selectedType: comicsConstants.type.carousel,
    typeList: [
      comicsConstants.type.carousel,
      comicsConstants.type.instagram,
    ],
    isFullScreen: false,
    isPreviewShowing: true,
    isShowStarWarsAnim: true,
    isAnimationRunning: true,
    breakpoints: useBreakpoints(),
    config: useRuntimeConfig(),
    season: 1,
    mode: 2,
    isAnimationFast: false,
    baseDuration: 60,
    fastDuration: 20,
    animationStartTime: null,
    currentDuration: 60,
    currentDelay: 0,
    isNextVisible: false,
    nextButtonTimer: null,
    pauseStartTime: null,

    holdSpeedTimer: null,
    isHoldActive: false,
    isHoldPointerDown: false,
    holdPrevIsFast: null,
    suppressNextClick: false,
    holdPointerId: null,
  }),
  watch: {
    isShowComics(newValue) {
      if (newValue) {
        this.isPreviewShowing = true
        this.isShowStarWarsAnim = true
        this.isAnimationRunning = true
        document.documentElement.style.overscrollBehavior = 'none'
      }
      else {
        document.documentElement.style.overscrollBehavior = ''
      }
    },
  },
  mounted() {
    const body = document.body
    if (body) {
      body.classList.add('body-modal-open')
    }

    this.baseDuration = this.breakpoints.xsOnly ? 65 : 60
    this.fastDuration = this.breakpoints.xsOnly ? 25 : 20

    this.currentDuration = this.baseDuration
    this.currentDelay = 0

    window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeUnmount() {
    document.documentElement.style.overscrollBehavior = ''
    window.removeEventListener('keydown', this.handleKeyDown)

    this.clearNextButtonTimer()

    const body = document.body
    if (body) {
      body.classList.remove('body-modal-open')
    }
  },
  methods: {
    openFullScreen() {
      this.isFullScreen = true
    },
    closeFullScreen() {
      this.isFullScreen = false
    },
    handleKeyDown(event) {
      switch (event.key) {
      case 'Escape':
        this.closeFullScreen()
        break
      }
    },
    skipAnim() {
      if (!this.isPreviewShowing && !this.isShowStarWarsAnim) return

      this.clearNextButtonTimer()
      this.isNextVisible = false

      this.isPreviewShowing = false
      this.isShowStarWarsAnim = false
    },
    selectType(type) {
      this.selectedType = type
    },
    closeComics() {
      const isVisible = useState(appStateConstants.IS_COMICS_VISIBLE)
      isVisible.value = false
    },
    toggleAnimation () {
      const now = performance.now()

      if (this.isAnimationRunning) {
        this.isAnimationRunning = false
        this.pauseStartTime = now
      }
      else {
        this.isAnimationRunning = true

        if (this.pauseStartTime != null && this.animationStartTime != null) {
          const pauseDuration = now - this.pauseStartTime
          this.animationStartTime += pauseDuration
        }

        this.pauseStartTime = null
      }
    },
    toggleSpeedAnimation () {
      if (!this.isAnimationRunning) return

      const el = this.$refs.crawl
      if (!el || this.animationStartTime == null) return

      const now = performance.now()
      const t = (now - this.animationStartTime) / 1000

      const D1 = this.currentDuration
      const d1 = this.currentDelay || 0

      let p = (t - d1) / D1
      if (p < 0) p = 0
      if (p > 1) p = 1

      const D2 = this.isAnimationFast ? this.baseDuration : this.fastDuration

      const d2 = t - p * D2

      el.style.animationDuration = `${D2}s`
      el.style.animationDelay = `${d2}s`

      this.currentDuration = D2
      this.currentDelay = d2
      this.isAnimationFast = !this.isAnimationFast
    },
    handleCrawlAnimationStart () {
      this.animationStartTime = performance.now()
      this.currentDuration = this.baseDuration
      this.currentDelay = 0
      this.isAnimationFast = false
      this.pauseStartTime = null

      this.isNextVisible = false
      this.startNextButtonTimer()
    },
    handleCrawlAnimationEnd () {
      this.clearNextButtonTimer()
      this.isNextVisible = false

      this.isShowStarWarsAnim = false
      setTimeout(() => {
        this.isPreviewShowing = false
      }, 100)
    },
    setSeason (value) {
      if (this.season === value) return
      // TODO: temp value
      if (value != 1) return
      this.season = value
    },
    setMode (value) {
      if (this.mode === value) return
      this.mode = value
    },
    startNextButtonTimer () {
      this.clearNextButtonTimer()
      if (this.animationStartTime == null) return
      this.nextButtonTimer = setInterval(this.checkNextButtonVisibility, 500)
    },
    clearNextButtonTimer () {
      if (this.nextButtonTimer) {
        clearInterval(this.nextButtonTimer)
        this.nextButtonTimer = null
      }
    },
    checkNextButtonVisibility () {
      if (!this.isShowStarWarsAnim) {
        this.clearNextButtonTimer()
        return
      }

      if (this.animationStartTime == null) return

      const now = performance.now()
      const t = (now - this.animationStartTime) / 1000

      const D = this.currentDuration || this.baseDuration
      const d = this.currentDelay || 0

      let p = (t - d) / D
      if (p < 0) p = 0
      if (p > 1) p = 1

      if (p >= 0.75) {
        this.isNextVisible = true
        this.clearNextButtonTimer()
      }
    },
    handleNextClick () {
      this.skipAnim()
    },
    handleSpeedHoldStart (e) {
      if (!this.isShowStarWarsAnim || !this.isPreviewShowing) return
      if (!this.isAnimationRunning) return
      if (this.isHoldPointerDown) return

      if (e?.target?.closest?.('.comics-icon')) return
      if (e?.target?.closest?.('.custom-anim-button')) return

      this.isHoldPointerDown = true
      this.isHoldActive = false
      this.suppressNextClick = false
      this.holdPrevIsFast = this.isAnimationFast
      this.holdPointerId = e.pointerId

      try {
        e.currentTarget?.setPointerCapture?.(e.pointerId)
      } catch (err) {}

      clearTimeout(this.holdSpeedTimer)
      this.holdSpeedTimer = setTimeout(() => {
        if (!this.isHoldPointerDown) return
        this.isHoldActive = true
        this.suppressNextClick = true
        this.toggleSpeedAnimation()
      }, 150)
    },
    handleSpeedHoldEnd (e) {
      if (!this.isHoldPointerDown) return

      this.isHoldPointerDown = false
      clearTimeout(this.holdSpeedTimer)
      this.holdSpeedTimer = null

      if (this.isHoldActive) {
        this.isHoldActive = false
        if (this.holdPrevIsFast != null && this.isAnimationFast !== this.holdPrevIsFast) {
          this.toggleSpeedAnimation()
        }
      }

      if (e?.currentTarget?.releasePointerCapture && this.holdPointerId != null) {
        try { e.currentTarget.releasePointerCapture(this.holdPointerId) } catch (err) {}
      }
      this.holdPointerId = null
    }
  },
  computed: {
    isFirstSeasonActive () {
      return this.season === 1
    }
  }
}
</script>

<style lang="scss" scoped>
.translations-component {
  position: fixed;
  z-index: 9000;
  left: 0px;
  bottom: 100px;
}
.comics-block {
  position: fixed;
  z-index: 9000;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  background-image: url('@/assets/images/comics/comics_background.png');
}
.view-content {
  margin-top: 110px;
  transition: all 1s ease;
}
.comics-header {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 3;
  padding-top: 16px;
  transition: all 1s ease;

  .header-name {
    color: #fff;
    margin-right: auto;
    font-size: 32px;
    line-height: 48px;
    text-align: center;
    font-weight: 400;
    user-select: none;
    text-transform: uppercase;
  }
  .header-sub-name {
    font-size: 24px;
    font-weight: 400;
    user-select: none;
    line-height: 28px;
    text-align: center;
    text-transform: uppercase;
  }
}
.comics-header.full-screen {
  top: -100px;
}
.not-full-screen-btn {
  position: absolute;
  right: -100px;
  top: 28px;
  z-index: 10;
  transition: all 1s ease;
}
.not-full-screen-btn.full-screen {
  right: 32px;
}
.navigation {
  position: absolute;
  right: 32px;
  top: 28px;
}
.view-content.full-screen {
  margin-top: 32px;
}
.custom-anim-button {
  position: absolute;
  background: none;
  border: 1px solid $yellow-100;
  color: $yellow-100;
  padding: 8px 24px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s linear;
  right: 32px;
  z-index: 10;
  font-size: 18px;

  &:hover {
    border: 1px solid $yellow-200;
    color: $yellow-200;
  }
}
.skip-button {
  top: 80px;
}
.pause-button {
  top: 135px;
}
.speed-button {
  top: 190px;
}
.next-button {
  left: 50%;
  right: auto;
  bottom: 10%;
  transform: translate(-50%, 100%);
  opacity: 0;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

.next-button--visible {
  transform: translate(-50%, 0);
  opacity: 1;
}
.star-wars {
  display: flex;
  justify-content: center;
  position: absolute;
  top: 120%;
  height: 500px;
  color: #feda4a;
  font-family: 'Pathway Gothic One', sans-serif;
  font-size: 500%;
  font-weight: 600;
  letter-spacing: 6px;
  line-height: 150%;
  perspective: 550px;
  text-align: justify;
}
.crawl {
  position: relative;
  top: 99999px;
  transform-origin: 50% 100%;
  animation: crawl 60s linear;

  &.paused {
    animation-play-state: paused;
  }
}
.carousel-view {
  transform: scale(1);
  transition: transform 3s ease, height 1s ease, top 1s ease;
  opacity: 1;
  position: absolute;
  top: 110px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2;
}
.carousel-view.full-screen {
  top: 32px;
}
.carousel-view.is-preview-showing {
  transform: scale(0.01);
  opacity: 0;
}

.launch-app-btn {
  position: absolute;
  bottom: 40px;
  right: 64px;
  z-index: 10;
}

@keyframes crawl {
  0% {
    top: -300px;
    transform: rotateX(20deg)  translateZ(0);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    top: -10460px;
    transform: rotateX(24deg) translateZ(-4000px);
  }
}

@media only screen and (max-width: $md) {
  .launch-app-btn {
    position: absolute;
    top: 28px;
    left: 32px;
    bottom: auto;
    right: auto;
    font-weight: 400;
  }
}

@media only screen and (max-width: $xs) {
  .header-name {
    margin-top: 56px;
  }
  .view-content {
    margin-top: 150px;
  }
  .comics-header.full-screen {
    top: -146px;
  }
  .fade {
    position: relative;
    width: 100%;
    min-height: 70vh;
    top: -150px;
    background-image:
      linear-gradient(to bottom, rgba(0, 0, 0, 1) 20%, rgba(0, 0, 0, 0) 100%),
      url('@/assets/images/comics/comics_background.png');

    background-size: cover;
    background-repeat: no-repeat;
    z-index: 1;
  }
  .carousel-view {
    top: 158px;
    transition: transform 3s ease, height 1s ease, top 1s ease;
  }
  .carousel-view.full-screen {
    top: 80px;
  }

  .view-content.full-screen {
    margin-top: 80px;
  }

  .star-wars {
    height: 800px;
    left: 0%;
    right: 0;
    top: 110%;
    font-size: 350%;
    perspective: 550px;
  }

  .crawl {
    animation: crawl 65s linear;
  }

  .skip-button {
    top: 130px;
  }
  .pause-button {
    top: 175px;
  }
  .speed-button {
    top: 220px;
  }

  @keyframes crawl {
    0% {
      top: -400px;
      transform: rotateX(20deg)  translateZ(0);
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      top: -13000px;
      transform: rotateX(25deg) translateZ(-4900px);
    }
  }
}
</style>
